import takeOutStore from '@/page/takeOut/Store';
import takeOutGoods from '@/page/takeOut/goods';
import takeOutOrder from '@/page/takeOut/order';
export const takeout = [
  {
  path: '/take/out/store',
  name: 'takeOutStore',
  component: takeOutStore,
  meta: {
    requireAuth: true,
    title: '门店管理'
  },
  },
  {
    path: '/take/out/goods',
    name: 'takeOutGoods',
    component: takeOutGoods,
    meta: {
      requireAuth: true,
      title: '商品管理'
    },
  },
  {
    path: '/take/out/order',
    name: 'takeOutOrder',
    component: takeOutOrder,
    meta: {
      requireAuth: true,
      title: '订单管理'
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/takeout.route.js